import { gqlFeature, gqlProfileSearchInput } from '@minecraft.graphql-types';
import { FilterValues } from '../../../shared/types';

export enum FilterDrawerType {
  Casting = 'casting',
  Reps = 'reps',
  TalentScout = 'talentScout',
}

export interface FilterDrawerProps<Values = FilterValues> {
  filterPermissions?: Record<string, boolean>;
  isSubmissionContext?: boolean;
  type: FilterDrawerType;
  isTalentScout?: boolean;
  roleId?: number;
  submissionStatusCode?: string;
  filterBasicRoute?: string;
  sessionStorageKey?: string;
  accountCountryCode?: string;
  accountOrgFeatures?: gqlFeature[];
  appliedFilters: Values;
  appliedQueryInput: gqlProfileSearchInput;
  onFiltersChange: (newFilters: Values) => void;
  getAdditionalAutofillFilters?: (autofillByRoleCriteria?: boolean) => Partial<FilterValues>;
}

export enum FiltersSectionNameEnum {
  topFilters = 'top_filters',
  additionalFilters = 'additional_filters',
}

export enum FiltersCategoryNameEnum {
  age = 'age',
  assets = 'assets',
  bookedOutDates = 'booked_out_dates',
  clothingSizes = 'clothing_sizes',
  documents = 'documents',
  ethnicAppearance = 'ethnic_appearance',
  excludeTalentWithConflicts = 'exclude_talent_with_conflicts',
  eyeColor = 'eye_color',
  facialHair = 'facial_hair',
  genderAppearance = 'gender_appearance',
  hairColor = 'hair_color',
  hairLengthStyle = 'hair_length_style',
  heightAndWeight = 'height_and_weight',
  multipleBirth = 'multiple_birth',
  newTalent = 'new_talent',
  otherExperience = 'other_experience',
  pregnancyDueDate = 'pregnancy_due_date',
  profession = 'profession',
  profileStatus = 'profile_status',
  representation = 'representation',
  rolePreferences = 'role_preferences',
  rosterLists = 'roster_lists',
  seekingRepresentation = 'seeking-representation',
  skills = 'skills',
  tattoosAndPiercings = 'tattoos_and_piercings',
  unionStatus = 'union_status',
  uniqueAttributes = 'unique_attributes',
  vehicle = 'vehicle',
  workingLocations = 'working_locations',
  workPermitExpirationDates = 'work_permit_expiration_dates',
}

export enum FiltersCountNameEnum {
  documentIds = 'documentIds',
  ethnicAppearanceIds = 'ethnicAppearanceIds',
  eyeColorId = 'eyeColorId',
  facialHairIds = 'facialHairIds',
  genderAppearanceIds = 'genderAppearanceIds',
  genderIdentityIds = 'genderIdentityIds',
  hairColorId = 'hairColorId',
  hairStyleId = 'hairStyleId',
  hasRepresentation = 'hasRepresentation',
  isNew = 'isNew',
  multipleBirthId = 'multipleBirthId',
  petIds = 'petIds',
  petSizeId = 'petSizeId',
  piercingIds = 'piercingIds',
  profileListIds = 'profileListIds',
  profileStatusToSearch = 'profileStatusToSearch',
  profileTypeId = 'profileTypeId',
  propIds = 'propIds',
  relationshipToMinorId = 'relationshipToMinorId',
  representativeListIds = 'representativeListIds',
  seekingRepresentations = 'seekingRepresentations',
  skillsId = 'skills.id',
  skillsSkillLevelId = 'skills.skillLevelId',
  sportEquipmentIds = 'sportEquipmentIds',
  tattooIds = 'tattooIds',
  uniqueAttributeIds = 'uniqueAttributeIds',
  vehicleMakeId = 'vehicle.makeId',
  wardrobeIds = 'wardrobeIds',
  willingnessIds = 'willingnessIds',
  workingLocationIds = 'workingLocationIds',
}
